// src/components/gallery/PhotoCard.jsx
import { Heart, Eye } from "lucide-react";

const PhotoCard = ({ photo, onClick }) => {
  return (
    <div
      onClick={() => onClick(photo)}
      className="group relative bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
    >
      <div className="aspect-square overflow-hidden">
        <img
          src={(photo.thumbnail || photo.url)+ "?w=400&h=400&fit=crop"}
          alt={photo.title}
          loading="lazy"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white font-medium mb-1">{photo.title}</h3>
          <div className="flex items-center justify-between text-white/80 text-sm">
            <span>{photo.uploadDate}</span>
            <div className="flex items-center space-x-3">
              <span className="flex items-center">
                <Heart className="h-3 w-3 mr-1" />
                {photo.likes}
              </span>
              <span className="flex items-center">
                <Eye className="h-3 w-3 mr-1" />
                {photo.views}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoCard;
